/**
 * @generated SignedSource<<07824e8bcbbdd364c2294c88fbcc46ca>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type RenameEmailLayoutInput = {
  id: string;
  name: string;
};
export type EmailLayoutViewRenameMutation$variables = {
  input: RenameEmailLayoutInput;
};
export type EmailLayoutViewRenameMutation$data = {
  readonly renameEmailLayout: {
    readonly id: string;
    readonly name: string;
  };
};
export type EmailLayoutViewRenameMutation = {
  response: EmailLayoutViewRenameMutation$data;
  variables: EmailLayoutViewRenameMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "EmailLayout",
    "kind": "LinkedField",
    "name": "renameEmailLayout",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EmailLayoutViewRenameMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EmailLayoutViewRenameMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "b379df07e40fcf6d42f99b1ee06f4d87",
    "id": null,
    "metadata": {},
    "name": "EmailLayoutViewRenameMutation",
    "operationKind": "mutation",
    "text": "mutation EmailLayoutViewRenameMutation(\n  $input: RenameEmailLayoutInput!\n) {\n  renameEmailLayout(input: $input) {\n    id\n    name\n  }\n}\n"
  }
};
})();

(node as any).hash = "b617222294b0f2857187d627c7f14484";

export default node;
